import { Box, Container, Fade } from "@mui/material";
import { SlideIn } from "ui";
import AppBar from "../components/AppBar";
import MainMenu from "../components/MainMenu"
import { Navigate, Route, Routes, useNavigate } from "react-router";
import { DashboardPage } from "./DashboardPage";
import ResultsTable from "./components/ResultsTable";
// import HistoryTable from "./components/HistoryTable";
import { WorkListContextProvider } from "../../context/WorkListsContext";
import KeywordTable from "./components/KeywordTable/KeywordTable";
import { useState } from "react";
import ShiftContainer from "../../components/ShiftContainer";
const IndexPageRoutes = () => {

    const navigate = useNavigate();

    return (
        <Routes>
            <Route index element={<DashboardPage />} />
            <Route path="/student/:studentId/sessions" element={(
                <ResultsTable
                    activeStudent={null}
                    onSelectedSession={(studentId: string, sessionId: string) => {
                        navigate(`/dashboard/student/${studentId}/session/${sessionId}/notes`)
                    }}
                    onBack={() => {
                        navigate(-1);
                    }} />
            )} />
            <Route path="/student/:studentId/session/:sessionId/keyword" element={(<KeywordTable
                onBack={() => { navigate(-1) }}
            />)} />
            {/* <Route path="student/:studentId/session/:sessionId/notes" element={(
                <HistoryTable
                    onBack={() => {
                        navigate(-1);
                    }} />
            )} /> */}
            <Route path="*" element={<Navigate to="." replace />} />
        </Routes>
    );
}


export default function IndexPage() {
    const [containerNode, setContainerNode] = useState<HTMLDivElement | null>(null)
    // const containerRef = useRef<HTMLDivElement>(null);
    return (
        <WorkListContextProvider>
            {/* <SlideInContextProvider> */}
            <AppBar />
            <SlideIn />
            <MainMenu />
            <ShiftContainer
                containerRef={containerNode}
            >
                <Fade appear in timeout={500}>
                    <Container ref={setContainerNode} maxWidth="xl">
                        <IndexPageRoutes />
                    </Container>
                </Fade>
            </ShiftContainer>
            {/* <Box sx={{
                    width: "100%",
                    transition: theme =>
                        theme.transitions.create('margin-left', {
                            duration: theme.transitions.duration.enteringScreen,
                            easing: theme.transitions.easing.easeOut,

                        }),
                    marginLeft: openMenu ? `${shift}px` : "0px"
                }}> */}

            {/* </Box> */}
            {/* </SlideInContextProvider> */}
        </WorkListContextProvider >
    )
}